import _asyncToGenerator from "F:/vue2.0+ vant/2024\u5E74\u9879\u76EE\u96C6\u5408/\u5143\u7FBF\u5B98\u7F51\u9879\u76EE\u96C6\u5408/\u5143\u7FBF\u4E2D\u6587\u7248\u672C/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import { ref, onMounted, onUnmounted, nextTick } from 'vue';
import { getDiseaseFieldList_url, getHomePipelineInnovationList_url } from "@/api"; //引入发送请求获取数据的方法

export default {
  components: {},
  name: 'Domain',
  setup: function setup() {
    // require('@/pages/index/images/banner1.png')
    var domainList = [// {
      //   id: 1,
      //   text: 'CDKL5 缺乏症（CDD）',
      //   iconImg: require('../images/pipeline_top_01.png'),
      // },
      // {
      //   id: 2,
      //   text: '难治性癫痫状态 (RSE)  ',
      //   iconImg: require('../images/pipeline_top_02.png'),
      // },
      // {
      //   id: 3,
      //   text: '特发性震颤',
      //   iconImg: require('../images/pipeline_top_03.png'),
      // },
    ];
    var domainIndex = ref(-1); // const displayedItems = ref(items.slice(0, 2))

    var showMore = ref(false);
    var activeNames = ref(-1);
    var articleList = ref([]);
    var hiddenIndex = ref(-1); // onMounted(() => {
    // })

    var onWindowScroll = null;
    var onWindowResize = null;

    var updateStickyState = function updateStickyState() {
      var lineTitleBoxFexd = document.querySelector('.line_title_box_fexd');
      var lineTitleBox = document.querySelector('.line_title_box');
      if (!lineTitleBoxFexd || !lineTitleBox) return; // Header 在不同分辨率下高度会变化，动态计算吸顶偏移，避免出现“真空”

      var headerEl = document.querySelector('.outer-container-header .long-container');
      var headerRect = headerEl ? headerEl.getBoundingClientRect() : null;
      var headerBottom = headerRect ? Math.max(headerRect.bottom, 0) : 0;
      lineTitleBoxFexd.style.setProperty('top', "".concat(Math.round(headerBottom), "px"), 'important');
      var lineTitleBoxRect = lineTitleBox.getBoundingClientRect();

      if (lineTitleBoxRect.top <= headerBottom) {
        lineTitleBoxFexd.style.display = 'block';
        lineTitleBoxFexd.style.opacity = '1';
      } else {
        lineTitleBoxFexd.style.display = 'none';
      }
    };

    onMounted( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              getDiseaseFieldList();
              getHomePipelineInnovationList();
              _context.next = 4;
              return nextTick();

            case 4:
              updateStickyState();

              onWindowScroll = function onWindowScroll() {
                return updateStickyState();
              };

              onWindowResize = function onWindowResize() {
                return updateStickyState();
              };

              window.addEventListener('scroll', onWindowScroll, {
                passive: true
              });
              window.addEventListener('resize', onWindowResize);

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));
    onUnmounted(function () {
      if (onWindowScroll) {
        window.removeEventListener('scroll', onWindowScroll);
      }

      if (onWindowResize) {
        window.removeEventListener('resize', onWindowResize);
      }
    });

    var getHomePipelineInnovationList = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return getHomePipelineInnovationList_url();

              case 2:
                res = _context2.sent;
                // console.log(res, "这是获取到的数据");
                articleList.value = res.data;

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function getHomePipelineInnovationList() {
        return _ref2.apply(this, arguments);
      };
    }();

    var fieldList = ref([]);

    var getDiseaseFieldList = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var res;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return getDiseaseFieldList_url();

              case 2:
                res = _context3.sent;
                fieldList.value = res.data;
                console.log(fieldList.value, 'fieldList'); // console.log(res,'疾病领域列表')

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function getDiseaseFieldList() {
        return _ref3.apply(this, arguments);
      };
    }();

    var toggleMore = function toggleMore(index) {
      if (index == activeNames.value) {
        activeNames.value = -1;
      } else {
        activeNames.value = index;
        hiddenIndex.value = -1; // console.log(activeNames.value, '看看是啥')
      }
    };

    var toggleMoreTrue = function toggleMoreTrue(index) {
      //点击头部ICON切换
      showMore.value = true;
      domainIndex.value = index;
    };

    var retract = function retract(name) {
      activeNames.value = -1;
    };

    var showPop = function showPop(val) {
      // console.log('我被执行了',val);
      hiddenIndex.value = val;
      activeNames.value = -1;
    };

    var closePop = function closePop() {
      hiddenIndex.value = -1; // console.log('关闭方法执行了', hiddenIndex.value)
    };

    return {
      fieldList: fieldList,
      domainList: domainList,
      domainIndex: domainIndex,
      showMore: showMore,
      toggleMoreTrue: toggleMoreTrue,
      toggleMore: toggleMore,
      activeNames: activeNames,
      articleList: articleList,
      hiddenIndex: hiddenIndex,
      retract: retract,
      showPop: showPop,
      closePop: closePop
    };
  }
};